/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalMonthlyGuildMember
 */
export interface GlobalMonthlyGuildMember {
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    guildIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    guildName: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalMonthlyGuildMember
     */
    totalPoints: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    profilePicture?: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalMonthlyGuildMember
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    id: string;
}

export function GlobalMonthlyGuildMemberFromJSON(json: any): GlobalMonthlyGuildMember {
    return GlobalMonthlyGuildMemberFromJSONTyped(json, false);
}

export function GlobalMonthlyGuildMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalMonthlyGuildMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guildIcon': !exists(json, 'guildIcon') ? undefined : json['guildIcon'],
        'guildName': json['guildName'],
        'totalPoints': json['totalPoints'],
        'nickname': json['nickname'],
        'profilePicture': !exists(json, 'profilePicture') ? undefined : json['profilePicture'],
        'rank': json['rank'],
        'id': json['id'],
    };
}

export function GlobalMonthlyGuildMemberToJSON(value?: GlobalMonthlyGuildMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guildIcon': value.guildIcon,
        'guildName': value.guildName,
        'totalPoints': value.totalPoints,
        'nickname': value.nickname,
        'profilePicture': value.profilePicture,
        'rank': value.rank,
        'id': value.id,
    };
}


